function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";
//Material UI
import Typography from "@mui/material/Typography";
//Limitless imports
import { createSuggestions } from "../../../utils/AutoCompleteDataUtil";
import { log as pilog } from "@limitless/common/utils";
import { withi18n } from "../../../../customer/components";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
export const GET_PRODUCE_CODES = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "tenant"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "group"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "locale"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "searchString"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getMsgClassificationCodes"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "tenantName"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "tenant"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupName"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "group"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "locale"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "locale"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "searchText"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "searchString"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "description"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 266,
    "source": {
      "body": "\n    query ($tenant: String!, $group: String!, $locale: String!, $searchString: String!) {\n        getMsgClassificationCodes(tenantName: $tenant, groupName: $group, locale: $locale, searchText: $searchString) {\n            id\n            description\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
class ProductCodeAutoComplete extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      searchString: ""
    });
    _defineProperty(this, "handleInputChange", value => {
      this.setState({
        searchString: value
      });
    });
    _defineProperty(this, "renderNoOptionsMessage", title => {
      const {
        t
      } = this.props;
      return /*#__PURE__*/React.createElement(Typography, {
        component: "span"
      }, t(title));
    });
  }
  render() {
    const {
      tenant,
      group,
      locale,
      onChange,
      selectedProduct,
      label,
      placeholder,
      isMandatory,
      isReadOnly
    } = this.props;
    const {
      searchString
    } = this.state;
    return /*#__PURE__*/React.createElement(Query, {
      query: GET_PRODUCE_CODES,
      variables: {
        tenant,
        group,
        locale,
        searchString
      },
      skip: searchString.length < 3
    }, ({
      loading,
      error,
      data
    }) => {
      const log = pilog.getLogger("ProductCodeAutoComplete render");
      let noOptionsTitle = "";
      let productCodeSuggestions = [];
      if (error) {
        log.error("Product Code Search failed ", error);
        noOptionsTitle = "An error has occured while searching";
      }
      if (!loading && !error && data) {
        var _data$getMsgClassific;
        log.debug(`${(_data$getMsgClassific = data.getMsgClassificationCodes) === null || _data$getMsgClassific === void 0 ? void 0 : _data$getMsgClassific.length} records found`);
        productCodeSuggestions = createSuggestions(data.getMsgClassificationCodes, {
          labelDataKey: "description",
          valueDataKey: "id"
        });
        log.debug(productCodeSuggestions);
      }
      if (searchString.length < 3) {
        noOptionsTitle = "Enter at least 3 characters to search";
      } else if (!data || !data.getMsgClassificationCodes || productCodeSuggestions.length === 0 && !loading) {
        noOptionsTitle = "No matches for this search term";
      }
      if (loading) {
        noOptionsTitle = "Searching...";
      }
      return /*#__PURE__*/React.createElement(DropdownMenu, {
        label: label,
        required: isMandatory,
        value: selectedProduct.value ? selectedProduct : null,
        id: "productCodeAutoComplete",
        fullWidth: true,
        options: productCodeSuggestions,
        placeholder: placeholder,
        onChange: async (event, value) => {
          onChange(value);
        },
        filterOption: () => true,
        noOptionsText: noOptionsTitle,
        isClearable: selectedProduct.value ? true : false,
        onInputChange: async (event, value) => {
          this.handleInputChange(value);
        },
        disabled: isReadOnly
      });
    });
  }
}
export default withi18n(ProductCodeAutoComplete);
ProductCodeAutoComplete.propTypes = {
  t: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  group: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedProduct: PropTypes.object,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  isMandatory: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool
};